/* FELGER · Price gate — revela precios solo tras revalidar código + hash activo (TTL 1h). */
(function () {
  "use strict";
  var STORAGE_KEY = "felger_fidelizado";
  /* FELGER rev3-27-07 · punto 32. El cliente pidio "30 minutos sin actividad
     en la pagina". Antes era 1 h FIJA desde la validacion del codigo, que es
     otra cosa: se caia igual aunque la persona estuviera cotizando. Ahora el
     reloj se reinicia con cada interaccion (ver renovarSesion). */
  var TTL_MS = 30 * 60 * 1000;

  function getAccessHashes() {
    var node = document.querySelector('[data-fg-price-access]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]').map(function (entry) {
        return String(entry.codigo_hash || '').trim().toLowerCase();
      }).filter(Boolean);
    } catch (e) { return []; }
  }

  function sha256(code) {
    if (!window.crypto || !window.crypto.subtle || !window.TextEncoder) {
      return Promise.reject(new Error('Web Crypto no disponible'));
    }
    var bytes = new window.TextEncoder().encode(code.trim().toUpperCase());
    return window.crypto.subtle.digest('SHA-256', bytes).then(function (buffer) {
      return Array.prototype.map.call(new Uint8Array(buffer), function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  async function getFidelizado() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.ts || !obj.codigo || !obj.codigo_hash) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      if (Date.now() - obj.ts > TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      var digest = await sha256(obj.codigo);
      var storedHash = String(obj.codigo_hash).trim().toLowerCase();
      var activeHashes = getAccessHashes();
      if (digest !== storedHash || activeHashes.indexOf(digest) === -1) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return obj;
    } catch (e) { return null; }
  }

  function fmtCLP(cents) {
    var n = Math.round(cents / 100);
    return "$ " + n.toLocaleString("es-CL");
  }

  /* FELGER rev3-27-07 · hallazgo CRITICO de la auditoria de codigo.
     revealPrices(null) salia por el `return` y NO revertia nada: al vencer la
     sesion por inactividad, `body.fg-fidelizado` y los precios ya destapados
     quedaban visibles para siempre en esa pestaña. El intervalo de 60 s
     revalidaba, obtenia null, y no pasaba nada.
     Esta funcion hace el camino inverso, y es la que corre cuando no hay
     sesion valida. */
  function hidePrices() {
    document.querySelectorAll('[data-fg-price]').forEach(function (el) {
      var pub = el.querySelector('[data-fg-price-public]');
      var gated = el.querySelector('[data-fg-price-gated]');
      var disc = el.querySelector('[data-fg-price-discount]');
      if (pub) pub.hidden = false;
      if (gated) gated.hidden = true;
      if (disc) {
        disc.hidden = true;
        disc.textContent = '';
        disc.classList.remove('fg-price__discount--active');
      }
    });
    if (document.body) {
      document.body.classList.remove('fg-fidelizado');
    }
  }

  function revealPrices(fid) {
    if (!fid) {
      hidePrices();
      return;
    }
    var pct = parseFloat(fid.descuento_pct || 0);
    document.querySelectorAll('[data-fg-price]').forEach(function (el) {
      var pub = el.querySelector('[data-fg-price-public]');
      var gated = el.querySelector('[data-fg-price-gated]');
      if (!gated) return;
      if (pub) pub.hidden = true;
      gated.hidden = false;
      var baseCents = parseFloat(el.getAttribute('data-fg-price-clp')) || 0;
      if (baseCents <= 0) {
        if (!gated.getAttribute('data-fg-quote')) {
          gated.setAttribute('data-fg-quote', '1');
          gated.innerHTML = '<span class="fg-price__quote" style="font-family:var(--fg-font-mono,monospace);font-size:0.82rem;letter-spacing:0.08em;color:#14264A;">PRECIO A COTIZAR</span>';
        }
        return;
      }
      // Compute discount if applicable
      if (pct > 0) {
        var priceCents = parseFloat(el.getAttribute('data-fg-price-clp')) || 0;
        var discCents = priceCents * (1 - pct / 100);
        var disc = el.querySelector('[data-fg-price-discount]');
        if (disc) {
          disc.hidden = false;
          disc.textContent = fmtCLP(discCents) + " · " + pct + "% de descuento aplicado";
          disc.classList.add("fg-price__discount--active");
        }
      }
    });
    // Also swap the announcement bar or add a signed-in badge
    var body = document.body;
    if (body && !body.classList.contains("fg-fidelizado")) {
      body.classList.add("fg-fidelizado");
    }
  }

  function autoApplyDiscount(fid) {
    if (!fid || !fid.codigo) return;
    var pct = parseFloat(fid.descuento_pct || 0);
    if (pct <= 0) return;

    // Solo aplicar en cart/checkout; no cascadear en cada page.
    var path = window.location.pathname;
    var onCart = /^\/cart($|\/|\?)/i.test(path);
    var onCheckout = /^\/checkouts?\//i.test(path);
    if (!onCart && !onCheckout) return;

    // Evitar loops: si ya se aplicó y viene del propio flow, marcar TS.
    // El discount code se aplica via /discount/CODE?redirect=/cart, Shopify
    // guarda el aplicado en la sesion del cart. Guardamos un flag efímero.
    var appliedKey = "felger_discount_applied_" + fid.codigo;
    var lastApplied = sessionStorage.getItem(appliedKey);
    if (lastApplied) return;

    // Marcamos ANTES del redirect para no loopear.
    sessionStorage.setItem(appliedKey, String(Date.now()));

    var url = "/discount/" + encodeURIComponent(fid.codigo) + "?redirect=" + encodeURIComponent(path + window.location.search);
    window.location.replace(url);
  }

  /* FELGER rev3-27-07 · punto 32: la sesion vence por INACTIVIDAD, no por
     tiempo transcurrido. Cada interaccion real reinicia el reloj. Se limita a
     una escritura cada 30 s para no castigar el scroll con un write por evento. */
  var ultimaRenovacion = 0;

  function renovarSesion() {
    var ahora = Date.now();
    if (ahora - ultimaRenovacion < 30000) return;
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var obj = JSON.parse(raw);
      if (!obj || !obj.ts) return;
      /* Si ya venció, no la revivimos: que la limpie getFidelizado. */
      if (ahora - obj.ts > TTL_MS) return;
      obj.ts = ahora;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
      ultimaRenovacion = ahora;
    } catch (e) {
      /* localStorage lleno o sesion corrupta: getFidelizado se encarga. */
    }
  }

  ["click", "keydown", "scroll", "pointerdown"].forEach(function (evento) {
    window.addEventListener(evento, renovarSesion, { passive: true });
  });

  async function init() {
    var fid = await getFidelizado();
    revealPrices(fid);
    autoApplyDiscount(fid);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  // Re-check every 60s in case the code was set in another tab
  setInterval(init, 60000);
})();
